<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"
  ><path
    stroke="#98A2B3"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.66667"
    d="m10.5883 15.3034-1.17848 1.1785c-1.62718 1.6272-4.26537 1.6272-5.89256 0-1.62718-1.6272-1.62718-4.2654 0-5.8926l1.17851-1.1785m10.60663 1.1785 1.1785-1.1785c1.6272-1.62719 1.6272-4.26538 0-5.89256-1.6272-1.62718-4.2654-1.62718-5.8926 0L9.40982 4.69675M7.08241 12.9167l5.83329-5.83333"
    style="stroke:#98a2b3;stroke:color(display-p3 .5964 .6352 .7017);stroke-opacity:1"
  /></svg
>
